import React from 'react';
import { Box, Typography } from '@mui/material';

const listItemStyle = {
    marginBottom: '0.75rem',
  };
  
const WalletSection = () => {
  return (
    <Box sx={{ px: { xs: 2, sm: 4 }, py: 2 }}>
      <Typography paragraph>
        The Wallet Page serves as the financial hub for your WatchNod account. It enables you to monitor past transactions, manage your wallet balance, and view details of your active subscriptions.
      </Typography>

      {/* Transaction History Section */}
      <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
        Transaction History Section
      </Typography>
      <ul style={{ paddingLeft: '1.25rem' }}>
        <li style={listItemStyle}>
          <Typography variant="body1">
            <strong>Payment Transaction Table:</strong> A table that displays transaction ID, payment date, transaction amount, and the status of each payment.
          </Typography>
        </li>
        <li style={listItemStyle}>
          <Typography variant="body1">
            <strong>Remaining Balance Display:</strong>  Clearly shows the current wallet balance.
          </Typography>
        </li>
        <li style={listItemStyle}>
          <Typography variant="body1">
            <strong>Add Balance Button:</strong> A user-friendly button that allows you to securely add funds to your wallet.
          </Typography>
          <ul style={{paddingLeft:'15px'}}>
            <li >Payment Options: Available in both USD and INR.</li>
            <li>The selected amount is shown inclusive of tax.</li>
            <li>After payment, the wallet balance reflects the base amount (excluding GST).</li>
          </ul>
        </li>
      </ul>

      {/* Monthly Invoice Section */}
      <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
        Monthly Plan Expenses
      </Typography>
      <ul style={{ paddingLeft: '1.25rem' }}>
        <li style={listItemStyle}>
          <Typography variant="body1">
           <strong>Monthly Expense Summary: </strong> Displays the total amount spent on plans during the current month.
          </Typography>
        </li>
        <li style={listItemStyle}>
          <Typography variant="body1">
            <strong>Graphical Overview: </strong>  A visual chart or graph represents your monthly spending trends.
          </Typography>
        </li>
      </ul>
    </Box>
  );
};

export default WalletSection;
